import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom"; // Add Router for react-router functionality
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NavigationBar from "./components/navbar/NavigationBar";
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    {/* Wrap the entire app with BrowserRouter for routing support */}
    <Router>
      {/* ToastContainer for notifications */}
     
      <ToastContainer
        toastClassName="relative flex py-4 px-3 rounded overflow-hidden cursor-pointer bg-white shadow-lg"
        bodyClassName="text-black text-base font-normal"
        position="bottom-left"
        autoClose={4000}
        hideProgressBar={true}
        newestOnTop={false}
        closeButton={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {/* Render the main App component */}
      <App />
    </Router>
  </React.StrictMode>
);
